import React from "react";
import "./HomePage.css";
import Logo from "../assets/images/Elogo.jpeg";
import { useState, useEffect } from "react";
import { HostApi } from "../configuration";
import axios from "axios";
import video from '../assets/images/hero.mp4'
import { useNavigate } from "react-router-dom";
const HomePage = () => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedbacks, setFeedbacks] = useState([]);
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  // Detect screen size
  const cardsPerView = window.innerWidth <= 768 ? 1 : 3;

  const handleSubmit = async () => {
    if (!name || !email || !message || !phone) {
      setMsg("All fields are required");
      return;
    }
    if (phone.length !== 10) {
      setMsg("Enter a valid 10-digit number");
      return;
    }
    try {
      setLoading(true);
      setMsg("");


      const res = await axios.post(
        `${HostApi()}/api/Advisor/servicerequest`,
        {
          name: name,
          email: email,
          phone: phone,
          message: message
        }
      );

      if (res.data) {
        setMsg("Message sent successfully ✅");

        // clear fields
        setName("");
        setEmail("");
        setMessage("");
      }
      setPhone("");

    } catch (err) {
      setMsg("Server error ❌");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const res = await axios.get(`${HostApi()}/api/Advisor/feedback`);
        setFeedbacks(res.data);
      } catch (err) {
        console.log("Error fetching feedback");
      }
    };

    fetchFeedback();
  }, []);

  // ================= STAR FUNCTION =================
  const renderStars = (rating) => {
    let stars = "";

    for (let i = 1; i <= 5; i++) {
      stars += i <= rating ? "⭐" : "☆";
    }

    return stars;
  };
  useEffect(() => {

    const interval = setInterval(() => {

      nextSlide();

    }, 5000);

    return () => clearInterval(interval);

  }, [currentIndex]);
  const nextSlide = () => {

    if (currentIndex + cardsPerView >= feedbacks.length) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };
  const prevSlide = () => {

    if (currentIndex === 0) {
      setCurrentIndex(feedbacks.length - cardsPerView);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="home">

      <img
        src={Logo}
        alt="Watermark"
        className="logo-watermark"
      />

      {/* HERO SECTION */}
      <section className="Homehero">

        {/* VIDEO BACKGROUND */}
        <video autoPlay loop muted playsInline className="hero-video">
          {/* <source src="./assets/images/hero.mp4" type="video/mp4" /> */}
          <source src={video} type="video/mp4" />
        </video>


      </section>

      {/* <section className="hero">
        <div className="hero-content">
          <h1>EAdvisor Solution</h1>
          <p>Your One-Stop Business & Compliance Partner</p>
          <button>Get Started</button>
        </div>
      </section> */}

      {/* SERVICES */}
      <section className="services1">
        <h2>Our Services</h2>
        <div className="service-grid1">
          <div className="card1" onClick={() => navigate("/company-registration")}>📄 Company Registration </div>
          <div className="card1" onClick={() => navigate("/gst-registration")} >💰 GST & Tax Filing</div>
          <div className="card1" onClick={() => navigate("/trademark")} >™ Trademark & IP</div>
          <div className="card1" onClick={() => navigate("/import-export-code")}>🌍 Import Export License</div>
          {/* <div className="card1" onClick={() => navigate("/company-registration")} >📊 Accounting</div>
          <div className="card1" onClick={() => navigate("/company-registration")}>⚖ Compliance Services</div> */}
        </div>
      </section>

      {/* STATS */}
      <section className="stats">
        <div className="stat">
          <h3>5000+</h3>
          <p>Happy Clients</p>
        </div>
        <div className="stat">
          <h3>200+</h3>
          <p>Services</p>
        </div>
        <div className="stat">
          <h3>1000+</h3>
          <p>Projects Completed</p>
        </div>
      </section>

      {/* WHY US */}
      <section className="why">
        <h3>Why Choose Us ?</h3>

        <div className="why-grid">
          <div className="why-card">We Are Not Just Consultants — We Are Your Strategic Growth Partners</div>
          <div className="why-card">Complete Business Solutions Under One Roof</div>
          <div className="why-card">Expert-Driven Approach With Real Industry Experience</div>
          <div className="why-card">Seamless Support From Startup To Scaling Stage</div>
          <div className="why-card">100% Compliance-Focused And Legally Sound Processes</div>
          <div className="why-card">Transparent Communication And Long-Term Relationship building</div>
        </div>

        <p className="why-footer">We don’t just guide you — we grow with you 🚀</p>
      </section>

      {/* TESTIMONIALS */}
      {/* <section className="testimonials">
        <h2>What Clients Say</h2>
        <div className="testimonial-card">
          <p>"Excellent service and fast response!"</p>
          <h4>- Client Name</h4>
        </div>
      </section> */}



      {/* For db */}

      {/* <section className="client-feedback">

        <div className="feedback-header">

        
          <button className="slide-btn" onClick={prevSlide}>
            {"<"}
          </button>

        
          <h2>Client Feedback</h2>

        
          <button className="slide-btn" onClick={nextSlide}>
            {">"}
          </button>

        </div>

        <div className="feedback-grid">

          {feedbacks.length > 0 ? (

            feedbacks
              .slice(currentIndex, currentIndex + cardsPerView)
              .map((item, index) => (

                <div className="feedback-card" key={index}>

                  <p>"{item.message}"</p>

                  <h4>{renderStars(item.rating)}</h4>

                  <span>- {item.name}</span>

                </div>
              ))

          ) : (
            <p>No feedback available</p>
          )}

        </div>

      </section> */}

      {/* CONTACT */}
      <section className="contact-ui">
        <div className="contact-container">

          {/* LEFT SIDE (2 CARDS ONLY) */}
          <div className="contact-left">

            <div className="contact-card">
              <h3>📞 Call Us</h3>
              <a href="tel:9218103915">
                <p className="contact-text">+91 9218103915</p>
              </a>
              <span>Mon - Sat (9 AM - 7 PM)</span>
            </div>

            <div className="contact-card">
              <h3>📧 Email Us</h3>
              <a href="mailto:Support@e-advisorssolution.com">
                <p className="contact-text">Support@e-advisorssolution.com</p>
              </a>
              <span>We reply within 24 hours</span>
            </div>

          </div>

          {/* RIGHT SIDE FORM */}
          <div className="contact-form">

            <h2>Get Expert Assistance</h2>

            <div className="form-row">
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <input
                type="number"
                placeholder="Mobile No."
                value={phone}
                onChange={(e) => setPhone(e.target.value.slice(0, 10))}
              />
            </div>

            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <textarea
              placeholder="Requirements...."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>

            <button onClick={handleSubmit} disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>

            {/* MESSAGE */}
            {msg && <p className="form-message">{msg}</p>}

          </div>

        </div>
      </section>
    </div>
  );
};

export default HomePage;